import {Search} from "js-search";
import {type BoidAssignmentState, statusFor} from "../../model";
import {type SearchFunction} from "./SearchFunction";

/**
 * Builds a search function for BoidAssignmentState[] that includes translated product names.
 * @param boids - Array of BoidAssignmentState
 * @param t - Translation function
 * @param entityId - The entity ID for context
 * @returns SearchFunction
 */
export const buildSearch = (
  boids: BoidAssignmentState[],
  t: (key: string) => string,
  entityId: string
): SearchFunction => {
  // Add translated product field to each boid
  const boidsWithProduct = boids.map(boid => {
    const status = statusFor(boid, entityId);
    return {
      ...boid,
      product: t(`entity-detail.business-operation-types.${boid.type}`),
      operationalBoidStatus: t(`entity-detail.boid-assignment-status.${status}`)
    };
  });

  const search = new Search("id");
  search.addIndex("product");
  search.addIndex("id");
  search.addIndex("operationalBoidStatus");
  search.addIndex("type");
  search.addIndex("sourceCaId");
  search.addIndex("subAccountStatus");

  search.addDocuments(boidsWithProduct);

  return (query: string): BoidAssignmentState[] => {
    if (boidsWithProduct.length === 0) return [];
    return search
      .search(query)
      .map(boid => boid as BoidAssignmentState)
      .sort((a, b) => {
        const typeComparison = a.type.localeCompare(b.type);
        if (typeComparison !== 0) return typeComparison;
        return a.id.localeCompare(b.id);
      });
  };
};
